import {defineMessages} from 'react-intl';

export const mobileMessages = defineMessages({
  gotIt: { id: 'mobile.got_it' },
  tapToExpand: { id: 'mobile.tap_to_expand' },
  tapToOpen: { id: 'mobile.tap_to_open' },
});
